import React from 'react';

import { Logo } from 'src/components/Logo';

import * as styles from './styles.css';

export const Header = () => <Logo className={styles.logoSize} />;
